import { Chip, makeStyles, Popover } from '@material-ui/core'
import React, { useState } from 'react'
import { Clear2Icon, CloseSmallIcon, DropDownIcon } from '@core'
import { findIndex, map } from 'lodash'
import { CentricTypography as Typography } from '@core/component/CentricTypography'
import { CNFAttributeFilterValueRow } from './CNFAttributeFilterValueRow'
import { useTranslation } from 'react-i18next'
import { isEmptyValue } from '@utils/object-utils'
import { stores } from '@stores'
import { getProductAttributeValue } from '@utils/get-product-attribute-value'

const useStyles = makeStyles(theme => ({
  filterChipsWrapper: {
    padding: '5px 15px 15px'
  },
  root: {
    minWidth: '208px',
    whiteSpace: 'normal',
    '&:focus': {
      backgroundColor: '#EEEEEE'
    }
  },
  paper: {
    padding: 10,
    maxHeight: '55%',
    overflow: 'auto'
  },
  clearIcon: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    marginTop: 8
  },
  chip: {
    marginRight: '8px',
    marginBottom: '8px',
    backgroundColor: '#EEEEEE',
    '&:focus': {
      backgroundColor: '#EEEEEE'
    }
  },
  removeIcon: {
    color: theme.palette.text.hint
  }
}))

export const CNFProductFilterChips = ({
  selectedFilters,
  clearFilter,
  filterAttributes,
  removeFilter,
  defaultEmptyText
}) => {
  const classes = useStyles()
  const { t } = useTranslation()
  const [anchorEl, setAnchorEl] = useState(null)
  const [dropDownKey, setDropDownKey] = useState('')
  const {
    productConfiguration: { defaultValuesFromConfig, findSpecificAttribute }
  } = stores

  const getTitleCaseValue = value => {
    const stringArr = value
      .split(' ')
      .map(ele => ele.charAt(0).toUpperCase() + ele.slice(1).toLowerCase())
    return stringArr.join(' ')
  }
  return (
    <div className={classes.filterChipsWrapper}>
      {map(Object.keys(selectedFilters), key => {
        const chipLabelIndex = findIndex(
          filterAttributes,
          (attribute: any) => attribute?.id === key
        )
        const attributeObj = findSpecificAttribute(key)
        let nodeText = selectedFilters[key]?.[0]?.value?.toString()
        if (attributeObj) {
          nodeText = getProductAttributeValue(
            { name: nodeText },
            attributeObj,
            true,
            defaultValuesFromConfig
          )
        }

        const text = nodeText || defaultEmptyText

        return chipLabelIndex !== -1 && selectedFilters[key].length ? (
          selectedFilters[key].length > 1 ? (
            <Chip
              deleteIcon={<DropDownIcon />}
              label={`${t(
                filterAttributes?.[chipLabelIndex]?.labelKey,
                filterAttributes?.[chipLabelIndex]?.displayName?.toUpperCase()
              )} ${
                selectedFilters?.[key]?.length
                  ? `(${selectedFilters?.[key]?.length})`
                  : ''
              }`}
              onClick={e => {
                setDropDownKey(key)
                setAnchorEl(e?.currentTarget)
              }}
              onDelete={e => {
                setDropDownKey(key)
                setAnchorEl(e?.currentTarget)
              }}
              className={classes.chip}
            />
          ) : (
            <Chip
              deleteIcon={<CloseSmallIcon className={classes.removeIcon} />}
              label={`${t(
                filterAttributes?.[chipLabelIndex]?.labelKey,
                filterAttributes?.[chipLabelIndex]?.displayName?.toUpperCase()
              )} - ${getTitleCaseValue(text)}`}
              onDelete={() => {
                removeFilter(false, selectedFilters[key]?.[0], key)
              }}
              className={classes.chip}
            />
          )
        ) : null
      })}
      <Popover
        id={'simple-popover'}
        anchorEl={anchorEl}
        open={Boolean(dropDownKey)}
        onClose={() => {
          setDropDownKey('')
          setAnchorEl(null)
        }}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        transformOrigin={{ vertical: 'top', horizontal: 'center' }}
        classes={{ paper: classes.paper }}
      >
        <>
          {map(selectedFilters?.[dropDownKey], option => {
            return (
              <div className={classes.root}>
                <CNFAttributeFilterValueRow
                  id={option?.value}
                  name={isEmptyValue(option?.value) ? defaultEmptyText : option?.value}
                  attributeId={dropDownKey}
                  canShowCheckbox={false}
                  handleFilterExclusion={() => {
                    removeFilter(false, option, dropDownKey)
                    if (selectedFilters?.[dropDownKey].length === 1) {
                      setDropDownKey('')
                      setAnchorEl(null)
                    }
                  }}
                  isExcluded={false}
                  filterCount={option?.count}
                />
              </div>
            )
          })}
          <div
            onClick={() => {
              clearFilter(dropDownKey)
            }}
          >
            <div className={classes.clearIcon}>
              <Clear2Icon />
              <Typography variant='captionDarkGrey'>
                {t('common.label.clear', 'Clear')}
              </Typography>
            </div>
          </div>
        </>
      </Popover>
    </div>
  )
}
